import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useEffect } from 'react';
import { styled, StyleSheet, text, padding, margin } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  menu: _objectSpread(_objectSpread(_objectSpread({
    display: 'block',
    listStyleType: 'none'
  }, padding.styles({
    target: 'actionMenu.menu',
    all: 'none'
  })), margin.styles({
    target: 'actionMenu.menu',
    all: 'none'
  })), {}, {
    minWidth: function minWidth(_ref) {
      var token = _ref.token;
      return token('actionMenu.menu.minWidth', '14rem');
    },
    '& a': _objectSpread({
      display: 'block',
      width: '100%'
    }, text.styles({
      target: 'actionMenu.item.link',
      fallback: 'link.default.idle',
      color: function color(_ref2) {
        var token = _ref2.token;
        return token('color.textStyle.body.default');
      },
      textDecoration: function textDecoration() {
        return 'none';
      }
    }))
  }),
  listItem: {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  menuItem: _objectSpread(_objectSpread(_objectSpread({
    cursor: 'pointer',
    display: 'block',
    width: '100%'
  }, text.styles({
    target: 'actionMenu.item',
    fallback: 'normal.default'
  })), padding.styles({
    target: 'actionMenu.item',
    x: 'm',
    y: 's'
  })), {}, {
    '&:hover': {
      backgroundColor: function backgroundColor(_ref3) {
        var token = _ref3.token;
        return token('actionMenu.item.hover.background.color', token('color.container.interactive.hover'));
      }
    }
  }),
  divider: _objectSpread(_objectSpread({
    width: '100%',
    height: '.1rem',
    display: 'flex'
  }, margin.styles({
    target: 'actionMenu.divider',
    all: 'none'
  })), {}, {
    backgroundColor: function backgroundColor(_ref4) {
      var token = _ref4.token;
      return token('actionMenu.divider.background.color', token('color.border.container.static.light'));
    }
  }),
  groupHeading: _objectSpread(_objectSpread({
    textTransform: 'uppercase'
  }, text.styles({
    target: 'actionMenu.heading',
    fallback: 'normal.semibold'
  })), padding.styles({
    target: 'actionMenu.heading',
    top: 's',
    x: 'xs',
    bottom: 'xs'
  }))
});

function ActionMenuContent(_ref5) {
  var items = _ref5.items,
      minWidth = _ref5.minWidth,
      maxWidth = _ref5.maxWidth,
      _ref5$ItemLabel = _ref5.ItemLabel,
      ItemLabel = _ref5$ItemLabel === void 0 ? 'a' : _ref5$ItemLabel,
      openedViaKeyboard = _ref5.openedViaKeyboard,
      setOpen = _ref5.setOpen,
      s = _ref5.styles;
  var menuRef = useRef();
  useEffect(function () {
    if (openedViaKeyboard.current) {
      var _menuRef$current$quer, _menuRef$current$quer2;

      (_menuRef$current$quer = menuRef.current.querySelector('[role="menuitem"]')) === null || _menuRef$current$quer === void 0 ? void 0 : (_menuRef$current$quer2 = _menuRef$current$quer.focus) === null || _menuRef$current$quer2 === void 0 ? void 0 : _menuRef$current$quer2.call(_menuRef$current$quer);
      openedViaKeyboard.current = false;
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setOpen(false);
        return;
      }

      if (e.key === 'ArrowDown') {
        var _current$parentNode, _current$parentNode$n, _menuRef$current$quer5, _menuRef$current$quer6;

        var current = menuRef.current.querySelector('[role="menuitem"]:focus');

        if (!current) {
          var _menuRef$current$quer3, _menuRef$current$quer4;

          (_menuRef$current$quer3 = menuRef.current.querySelector('[role="menuitem"]')) === null || _menuRef$current$quer3 === void 0 ? void 0 : (_menuRef$current$quer4 = _menuRef$current$quer3.focus) === null || _menuRef$current$quer4 === void 0 ? void 0 : _menuRef$current$quer4.call(_menuRef$current$quer3);
          return;
        }

        var nextItem = (_current$parentNode = current.parentNode) === null || _current$parentNode === void 0 ? void 0 : (_current$parentNode$n = _current$parentNode.nextSibling) === null || _current$parentNode$n === void 0 ? void 0 : _current$parentNode$n.querySelector('[role="menuitem"]');

        if (nextItem) {
          nextItem === null || nextItem === void 0 ? void 0 : nextItem.focus();
          return;
        }

        (_menuRef$current$quer5 = menuRef.current.querySelector('[role="menuitem"]')) === null || _menuRef$current$quer5 === void 0 ? void 0 : (_menuRef$current$quer6 = _menuRef$current$quer5.focus) === null || _menuRef$current$quer6 === void 0 ? void 0 : _menuRef$current$quer6.call(_menuRef$current$quer5);
        return;
      }

      if (e.key === 'ArrowUp') {
        var _current$parentNode2, _current$parentNode2$, _items4;

        var _current = menuRef.current.querySelector('[role="menuitem"]:focus');

        if (!_current) {
          var _items3;

          var _items2 = menuRef.current.querySelectorAll('[role="menuitem"]');

          (_items3 = _items2[_items2.length - 1]) === null || _items3 === void 0 ? void 0 : _items3.focus();
          return;
        }

        var prevItem = (_current$parentNode2 = _current.parentNode) === null || _current$parentNode2 === void 0 ? void 0 : (_current$parentNode2$ = _current$parentNode2.previousSibling) === null || _current$parentNode2$ === void 0 ? void 0 : _current$parentNode2$.querySelector('[role="menuitem"]');

        if (prevItem) {
          prevItem === null || prevItem === void 0 ? void 0 : prevItem.focus();
          return;
        }

        var _items = menuRef.current.querySelectorAll('[role="menuitem"]');

        (_items4 = _items[_items.length - 1]) === null || _items4 === void 0 ? void 0 : _items4.focus();
      }
    }

    window.document.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.document.removeEventListener('keydown', handleKeyDown);
    };
  }, // eslint-disable-next-line
  []);
  return /*#__PURE__*/React.createElement("ul", _extends({
    ref: menuRef
  }, s.with('menu')({
    minWidth: minWidth,
    maxWidth: maxWidth
  }), {
    role: "menu"
  }), _mapInstanceProperty(items).call(items, function (item, index) {
    function handleMenuItemClick(e) {
      var _item$onClick;

      e.persist();
      (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, e);

      if (!e.defaultPrevented) {
        setOpen(false);
      }
    }

    function handleKeyDown(e) {
      if (e.key === 'Enter') {
        e.target.click();
      }
    }

    if (item.isCustomContent) {
      var Content = item.Content;
      return /*#__PURE__*/React.createElement("li", _extends({
        key: index
      }, s('listItem')), /*#__PURE__*/React.createElement(Content, _extends({
        tabIndex: 0,
        role: "menuitem",
        onClick: handleMenuItemClick,
        onKeyDown: handleKeyDown
      }, s('menuItem'))));
    }

    if (item.isDivider) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement("div", s('divider')));
    }

    if (item.isGroupHeading) {
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement("div", s('groupHeading'), item.label));
    }

    return /*#__PURE__*/React.createElement("li", _extends({
      key: index
    }, s('listItem')), /*#__PURE__*/React.createElement(ItemLabel, _extends({
      tabIndex: 0,
      role: "menuitem",
      onClick: handleMenuItemClick,
      onKeyDown: handleKeyDown
    }, s('menuItem')), item.label));
  }));
}

export default styled(defaultStyles)(ActionMenuContent);